import React, { useMemo ,  useState, useEffect  } from "react";
import { useSelector, useDispatch } from 'react-redux';
import Container from "@mui/material/Container";
import { useLocation, useNavigate } from "react-router-dom";
const PaginationCard = ({
  initialPageSize,
  pageNumber,
  onPageIndexChange,
  onPageSizeChange,
  enablePagination = true,
  totalRecords,
  className = "",
  handleViewProduct,
  recordCountText = "records found",
}) => {
  // Adjust pageNumber to zero-based indexing for useReactTable
  const pageIndex = useMemo(() => pageNumber - 1, [pageNumber]);
  const totalPages = useMemo(
    () => Math.ceil(totalRecords / initialPageSize),
    [totalRecords, initialPageSize]
  );
  const productDetails ={}
    // useSelector((state) => state.products.productList.data || {});
    const dispatch = useDispatch();
    const navigate = useNavigate();
  // const handleView = () => {
  //     onView({
  //         productId:productId,
  //         actionType: actionType
  //     });
  // };
  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    onPageSizeChange(newSize);
    onPageIndexChange(1);
  };
  const navigatePage = (action) => {
    switch (action) {
      case "first":
        onPageIndexChange(1);
        break;
      case "prev":
        onPageIndexChange(Math.max(1, pageNumber - 1));
        break;
      case "next":
        onPageIndexChange(pageNumber + 1);
        break;
      case "last":
        onPageIndexChange(Math.ceil(totalRecords / initialPageSize));
        break;
      default:
        break;
    }
  };
  const isFirstPage = pageNumber === 1;
  const isLastPage = pageNumber >= totalPages;
  const disabledButtonStyle = { color: "grey", cursor: "not-allowed" };
 // console.log("DATATAAAA", data);
  return (
    <>
      {/* HERE IS THE PAGINATION START */}
      <div className="d-flex justify-content-end py-2 mt-2">
        {/* <div className="text-filed">
      <p className="color-black font-14">{`${totalRecords} ${recordCountText}`}</p>
    </div> */}
        <div className="pagination">
          <div className="form-group white-drop mb-0">
            <select
              style={{
                display: "flex",
                width: "50px",
                flexDirection: "column",
                gap: "4px",
                height: "50px",
                alignItems: "center",
                paddingTop: "13px",
              }}
              value={initialPageSize}
              onChange={handlePageSizeChange}
            >
              {[10, 25, 50].map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
            <label className="text-nowrap font-14 py-3 ms-3 me-3">
              Per page
            </label>
          </div>
          <div className="pagination-wrapper">
            <button
              className="pagination-button"
              onClick={() => navigatePage("prev")}
              disabled={isFirstPage}
            >
              {"<"}
            </button>
            <div className="pagination-current-page">
              <span>{String(pageNumber).padStart(2, "0")}</span>{" "}
            </div>
            <span>of </span>
            <span className="ms-2">{String(totalPages).padStart(2, "0")}</span>
            <button
              className="pagination-button ms-2"
              onClick={() => navigatePage("next")}
              disabled={isLastPage}
            >
              {">"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaginationCard;
